import { computed } from 'mobx';

export default class DataExportModel {
  id;
  store;

  constructor(store, item) {
    this.store = store;
    this.id = +item.id;
    this.name = item.name;
    this.description = item.description;
    this.protocol = item.protocol;
    this.formatter = item.formatter;
    this.observation_req = item.observation_req;
    this.observation_offset = item.observation_offset;
    this.use_report_template = item.use_report_template;

    this.stations = item.stations || [];
    this.parameters = item.parameters || [];
    this.export_location_id = item.export_location_id;
    this.export_location = item.export_location || {};
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      description: this.description,
      protocol: this.protocol,
      formatter: this.formatter,
      observation_req: this.observation_req,
      observation_offset: this.observation_offset,
      use_report_template: this.use_report_template,

      stations: this.stations || [],
      parameters: this.parameters || [],
      export_location_id: this.export_location_id,
      export_location: this.export_location || {
        host: '',
        user_name: '',
        user_password: '',
        path: '',
        interval: '',
      },
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.description = json.description;
    this.protocol = json.protocol;
    this.formatter = json.formatter;
    this.observation_req = json.observation_req;
    this.observation_offset = json.observation_offset;
    this.use_report_template = json.use_report_template;

    this.stations = json.stations || [];
    this.parameters = json.parameters || [];
    this.export_location_id = json.export_location_id;
    this.export_location = json.export_location || {};
  }
}



// WEBPACK FOOTER //
// ./src/models/DataDelivery/DataExportModel.js